<template>
	<div class="loginbox">
		<h1 class="LogoTitle">保利剧院</h1>
		<div class="login">
			<p class="login-input">
				<input type="text" class="input" v-model="form.name" @focus="nameInput">
				<i class="el-icon-user-solid"></i>
			</p>
			<p class="login-input">
				<input type="password" class="input" v-model="form.password" @focus="passwordInput">
				<i class="el-icon-lock"></i>
			</p>
			<button @click="loginBtn" class="loginbtn">登录</button>
			<p v-if="check" class="checkContent">
				用户名或密码登录错误
			</p>
		</div>
	</div>
</template>

<script>
	import { login } from '@/api/index.js'
export default 
{
	data() 
	{
		return {
			form:{},
			restaurants: [],
			state: '',
			check:false,
			isExist:false,
		}
	},
	methods: 
	{
		// 登录
		loginBtn()
		{
			if(this.form.name==undefined)
			{
				this.$message.error('请输入用户名')
				return false;
			}
			if(this.form.password==undefined)
			{
				this.$message.error('请输入密码')
				return false;
			}
			login({data:this.form})
			.then((response)=>
			{
				if(response.data.code==500)
				{
					this.$message.error('用户名输入错误')
					this.check=true;
					return false;
				}
				else
				{
					if(response.data.data.isSuccess==false)
					{
						this.$message.error('密码错误')
						this.check=true;
						return false;
					}
					else
					{
						console.log(document.cookie,999)
						localStorage.setItem('userName',this.form.name)
						var meau=JSON.stringify(response.data.data.menuDto);
						localStorage.setItem('meau',meau)
						this.$store.dispatch('Login',this.form.name)
						this.$message.success('登录成功')
						this.$router.push('/home')
					}
				}
			})
		},
		nameInput()
		{
			this.check=false;
		},
		passwordInput()
		{
			this.check=false;
		},
		
	},
}
</script>

<style scoped>
	.loginbox{
		width: 100%;
		height: 100vh;
		background-color: #AABCD1;
	}
	.LogoTitle{
		padding-top: 100px;
		color: white;
		font-size: 40px;
	}
	.login{
		width: 30%;
		height: 20vw;
		background-color: white;
		margin-left: 35%;
		margin-top: 50px;
		padding-top: 30px;
	}
	.login-input{
		width: 90%;
		height: 40px;
		background-color: white;
		margin-left: 5%;
		margin-top: 3vw;
		border: solid 1px black;
	}
	.input{
		width: 79%;
		height: 40px;
		float: left;
		padding-left: 1%;
		border: none;
	}
	.login-input i{
		width: 20%;
		height: 40px;
		font-size: 30px;
		line-height: 40px;
		float: left;
	}
	.loginbtn{
		width: 20%;
		height: 30px;
		background-color: #3C8DBC;
		color: white;
		border: none;
		margin-top: 3vw;
		float: right;
		margin-right: 5%;
	}
	.checkContent{
		color: red;
		margin-top: 25px;
		text-align: left;
		padding-left: 20px;
	}
</style>